// extracted by mini-css-extract-plugin
export default {"searchbarContainer":"PatientsCheckbox_searchbarContainer__8wNUU","patientsChecklistContainer":"PatientsCheckbox_patientsChecklistContainer__m73YL"};